import context from 'static/script/app/ui/checkout2/context/context';
riot.tag2('swish-app2app-payment', '<div class="co-radio-new {co-radio-selected:model.selectedPaymentType === \'SwishApp2App\'}"> <div class="header" onclick="{selectPaymentType}"> <div class="cell"> <div class="checkmark"></div> </div> <div class="cell"> <div class="icon-braintree-swish"></div> </div> <div class="cell cell-title"> &nbsp; </div> <div class="cell-right"> &nbsp; </div> </div> </div>', '', '', function(opts) {
        const self = this;
        this.context = context;
        this.model = opts.model;
        this.useMobileFlow = this.model.isAutoStartAllowed;

        this.context.observable.on('payment-type-selected', function (type) {
            if (type === 'SwishApp2App')
                this.context.observable.trigger('payment-valid');
        }.bind(this));

        this.context.observable.on('payment-requires-user-confirmation', function (paymentType, paymentResponse) {

            if (paymentType !== 'SwishApp2App')
                return;
            let location = window.location.href;
            this.model.qrCode = paymentResponse.swishApp2App.qrCode;
            this.model.purchaseOrderId = paymentResponse.purchaseOrderId;

            if (this.model.isAutoStartAllowed && this.useMobileFlow && this.model.swishCallbackUrl) {
                startSwish(paymentResponse.swishApp2App.payload, this.model.swishCallbackUrl);

                // open modal with delay
                setTimeout(() => {
                    this.modal = this.context.modal.showModal('checkout-modal',
                        {
                            title: this.t("checkout_swishApp2App_modal1title"),
                            bodyTagName: 'swish-app2app-modal-body',
                            bodyTagModel: { model: this.model },
                            nonDismissible: true,
                            showProgressIcon: false,
                            buttons: {
                                primary: {
                                    title: this.t("checkout_swishApp2App_modal1primaryButton"),
                                    click: function () {
                                        completeSwishApp2AppPayment(paymentResponse.purchaseOrderId);
                                        paymentResponse.successMessage = this.t("checkout_swishApp2App_successMessage");
                                        this.context.observable.trigger('payment-confirmed-by-user', 'SwishApp2App', paymentResponse);
                                    }.bind(this)
                                },
                                secondary: {
                                    title: this.t("checkout_swishApp2App_modal1secondaryButton"),
                                    click: function (model) {
                                        this.isCanceled = true;
                                        model.close();
                                        window.location.href = location;

                                    }.bind(this)
                                }
                            }
                        });
                }, 3000);
            }
            else {
                this.modal = this.context.modal.showModal('checkout-modal',
                    {
                        title: this.t("checkout_swishApp2App_modal2title", {amount: paymentResponse.swishApp2App.amount}),
                        bodyTagName: 'swish-app2app-modal-body',
                        bodyTagModel: { model: this.model },
                        nonDismissible: true,
                        showProgressIcon: false,
                        buttons: {
                            primary: {
                                title: this.t("checkout_swishApp2App_modal2primaryButton"),
                                click: function () {
                                    completeSwishApp2AppPayment(paymentResponse.purchaseOrderId);
                                    paymentResponse.successMessage = this.t("checkout_swishApp2App_successMessage");
                                    this.context.observable.trigger('payment-confirmed-by-user', 'SwishApp2App', paymentResponse);
                                }.bind(this)
                            },
                            secondary: {
                                title: this.t("checkout_swishApp2App_modal2secondaryButton"),
                                click: function (model) {
                                    this.isCanceled = true;
                                    model.close();
                                }.bind(this)
                            }
                        }
                    });
            }
            this.isCanceled = false;
        }.bind(this));

        function startSwish(payload, callbackUrl) {
            window.location.href = 'swish://payment?data=' + encodeURIComponent(payload) + '&callbackurl=' + encodeURIComponent(callbackUrl) + '&callbackresultparameter=result';
        }

        function completeSwishApp2AppPayment(purchaseOrderId) {
            $.ajax({
                type: 'POST',
                url: self.toLocalizedUrl('/shopping/swishapp2app/confirm'),
                contentType: 'application/json; charset=utf-8',
                data: JSON.stringify({ purchaseOrderId: purchaseOrderId }),
                success: data => { console.log(data); },
                error: data => { console.log(data); }
            });
        }

        this.selectPaymentType = () => {
            if (this.model.selectedPaymentType === 'SwishApp2App')
                return;

            this.context.observable.trigger('payment-type-selected', 'SwishApp2App');
        }
});
